/**
 *
 */
import d2fmt from '@/ddv2.library/utils/formatter'
import date from '@/ddv2.library/date'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'

import complements from '@/rahmen/complement'
import controls from '@/rahmen/controls'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDialog = () => import('@/components/DdDialog')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdIconButton = () => import('@/components/DdIconButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'JuchuEdit',
  mixins: [flowMixin],
  data: () => ({
    // データテーブルヘッダー定義
    meisaiHeaders: [
      { text: '#', value: 'juchuMeisaiNo', width: '2%', sortable: false },
      { text: '作業予定日', value: 'sagyoYoteiYmdString', width: '5%', sortable: false },
      { text: '荷主', value: 'ninushiNm', width: '10%', sortable: false },
      { text: '発地', value: 'hatsuchiNm', width: '8%', sortable: false },
      { text: '発日付', value: 'hatsuchiYmd', width: '5%', sortable: false, align: 'center' },
      { text: '発時刻', value: 'hatsuchiHms', width: '4%', sortable: false, align: 'center' },
      { text: '卸先', value: 'oroshisakiNm', width: '10%', sortable: false },
      { text: '着地', value: 'chakuchiNm', width: '8%', sortable: false },
      { text: '着日付', value: 'chakuchiYmd', width: '5%', sortable: false, align: 'center' },
      { text: '着時刻', value: 'chakuchiHms', width: '4%', sortable: false, align: 'center' },
      { text: '金額計', value: 'seikyuKingaku', width: '8%', sortable: false, align: 'right' },
      { text: '作業担当', value: 'sagyoSbtNm', width: '6%', sortable: false },
      { text: '発注委託', value: 'hacchuSbtNm', width: '6%', sortable: false },
      { text: '操作', value: 'actions', width: '8%', sortable: false },
      { text: '品目展開', value: 'data-table-expand', width: '6%', sortable: false }
    ],
    hinmokuHeaders: [
      { text: 'MNo.', value: 'juchuMeisaiNo', width: '5%', sortable: false, filterable: true, align: ' d-none' },
      { text: '品目番号', value: 'juchuHinmokuNo', width: '5%', sortable: false, filterable: false },
      { text: '品目種別', value: 'hinmokuSbtNm', width: '10%', sortable: false, filterable: false },
      { text: '商品名', value: 'hinmeiNm', width: '15%', sortable: false, filterable: false },
      { text: '数量', value: 'juchuSuryo', width: '7%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '単位', value: 'unitKbnNm', width: '7%', sortable: false, filterable: false, align: 'center' },
      { text: '重量', value: 'juchuJuryo', width: '7%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '才数', value: 'juchuSaisu', width: '7%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '単価', value: 'tanka', width: '8%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '金額', value: 'kingaku', width: '8%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '操作', value: 'actions', width: '13%', sortable: false }
    ],
    // ヘルプヘッダー定義
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,
    // 変数定義
    IsReadOnly: false,
    id: 0,
    modeKengen: 0,
    copyMode: 0,
    baseYmd: '',
    mapData: [],
    rec: {
      juchuKingaku1: {},
      juchuMeisai: [],
      hacchuKihon: {
        hacchuKingaku1: {}
      }
    },
    isShowMeisaiDialog: false,
    meisaiDialogTarget: {
      juchuKingaku1: {},
      juchuHinmoku: [],
      hacchuKihon: {
        hacchuKingaku1: {}
      },
      sagyoMeisai: {},
      sagyoKingaku1: {},
      sagyoHinmoku: [],
      ninushi: { torihikisakiCd: null },
      hatsuchi: { hacchakuchiCd: null },
      oroshisaki: { torihikisakiCd: null },
      chakuchi: { hacchakuchiCd: null }
    },
    isShowHinmokuDialog: false,
    hinmokuDialogTarget: {
      juchuKingaku1: {},
      hinmei: { hinmeiCd: null },
      hinmokuSbtMst: {},
      unitKbnMst: {}
    },
    hinmeiSwitch: false,
    currentMstKingaku: {}
  }),
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDialog,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdEditDialog,
    DdFooterButton,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRowCountBox,
    DdSubHeader,
    DdSwitch,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdTimeBox
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    filterdOfukuKubunList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF052')
    },
    filterdTaniKubunList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    filterdHinmokuShubetsuKubunList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    filterdSeikyuShashuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filterdMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstTokuisaki () {
      const target = (this.rec.juchuYmdString) ? this.rec.juchuYmdString : this.baseYmd
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filterdMstHacchusaki () {
      const target = (this.rec.juchuYmdString) ? this.rec.juchuYmdString : this.baseYmd
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === true
      })
    },
    filterdMstEigyosho () {
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstHinmei () {
      if (this.rec.torihikisakiId !== '') {
        const a = this.torihikisakiList.find(l => {
          return l.id === this.rec.torihikisakiId
        })
        if (a) {
          return this.hinmeiList.filter(l => {
            return l.torihikisakiCd === a.torihikisakiCd
          }).map((elem) => {
            elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
            elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
            return elem
          })
        }
      }
      return []
    },
    filterdMstHacchakuchi () {
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstJinin () {
      return this.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    isTorihikisakiUsable () {
      const currentMaxNo = Math.max((this.rec.juchuMeisaiMaxNo ?? 0), Math.max.apply(null, this.rec.juchuMeisai.map(m => m.juchuMeisaiNo)))
      console.log('JuchuEdit', 'isTorihikisakiUsable', currentMaxNo)
      if (currentMaxNo !== 0) {
        return false
      }
      return true
    },
    isJuchuMeisaiUsable () {
      console.log('JuchuEdit', 'isJuchuMeisaiUsable', this.rec.torihikisakiId)
      if (!this.rec.torihikisakiId) {
        return false
      }
      return true
    },
    // 受注明細データ
    filteredJuchueisaiListRows () {
      // データがない場合の制御
      if (!this.rec.juchuMeisai.map) { return }

      return this.rec.juchuMeisai.map((elem) => {
        if (elem.hatsuchiYmd) { elem.hatsuchiYmd = filter.dateFormatter(elem.hatsuchiYmd) }
        if (elem.hatsuchiHms) { elem.hatsuchiHms = complements.parseTime(elem.hatsuchiHms, false).substr(0, 5) }
        if (elem.chakuchiYmd) { elem.chakuchiYmd = filter.dateFormatter(elem.chakuchiYmd) }
        if (elem.chakuchiHms) { elem.chakuchiHms = complements.parseTime(elem.chakuchiHms, false).substr(0, 5) }

        return elem
      })
    },
    isMapUsable () {
      // 明細レコードが存在しない場合
      if (this.rec === {}) { return false }
      if (this.rec.juchuMeisai === undefined) { return false }
      if (this.rec.juchuMeisai.length < 1) { return false }

      return true
    },
    detailAmount () {
      // 明細レコードが存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.juchuMeisai === undefined) { return 0 }

      let amount = 0

      // 集計
      this.rec.juchuMeisai.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(d2fmt.removeComma(target.seikyuKingaku))
      }).map(k => {
        // 金額項目を数値に変換
        return parseInt(d2fmt.removeComma(k.seikyuKingaku, 10))
      }).forEach(k => {
        amount += k
        console.log('JuchuEdit', 'forEach', amount)
      })

      // return filter.numericFormatter(amount)
      return amount
    },
    detailMeisaiAmount () {
      const target = this.meisaiDialogTarget.juchuKingaku1
      if (target === [] || target === null || target === undefined) { return 0 }

      const l = this.convertKingakuItemsToArray(target)

      if (l.length === 0) { return 0 }
      const amount = l.reduce((a, c) => a + c)
      return filter.numericFormatter(amount)
    },
    titleMeisaiSave () {
      if (this.meisaiDialogTarget.juchuMeisaiNo) {
        return '更新'
      } else {
        return '登録'
      }
    },
    formTitle (target) {
      if (target === undefined || target === null || target === {}) { return '登録' }
      return '更新'
    },
    /*
    currentMstKingaku () {
      if (this.rec.torihikisakiId === 0) { return {} }
      const mt = this.tokuisakiList.find((t) => {
        return t.mstTorihikisakiId === this.rec.torihikisakiId
      })
      if (mt === undefined || mt === null) { return {} }
      console.log('JuchuEdit.currentMstKingaku', mt)
      const mk = this.kingakuList.find((k) => {
        return k.id === mt.mstKingakuId
      })
      if (mk === undefined || mk === null) { return {} }
      return mk
    },
    */
    // 入力制御
    isMeisaiSeikyuYoteiYmd () {
      if (this.rec.ikkatsuSeikyuFlg) {
        return false
      } else {
        return true
      }
    },
    // ボタン制御系
    isUsableEdit () {
      if (this.modeKengen === 0) return false
      return true
    },
    isUsableDelete () {
      if (this.modeKengen === 2) return true
      return false
    },
    isNew () {
      if (this.id === 0) return true
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    /**
     * 初期化処理
     */
    initialize () {
      console.log('JuchuEdit', 'initialize', this.id)
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('JuchuEdit', 'initializeInputPromise')
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            console.log('JuchuEdit', 'savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('JuchuEdit', 'existsIdMethod', self.id)
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('JuchuEdit', 'settingButtonStatePromise', kengen)
            resolve()
          })
        }
      }
      console.info('JuchuEdit', 'call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    /**
     * 画面表示データ取得
     */
    fetchData () {
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/trjuchukihon/findwithchildren?id=${this.id}`)
          .then((data) => {
            // /* eslint no-debugger: "warn" */
            // debugger

            const x = data.payload

            if (x.hacchuKihon.id) x.hacchuSw = true
            x.juchuMeisai.forEach(m => {
              if (m.sagyoMeisai.id) m.sagyoSw = true
              if (m.hacchuKihon.id) m.hacchuSw = true
            })
            this.rec = x
            // 基準日設定
            this.baseYmd = x.juchuYmdString
            // 明細情報編集
            this.calculateMeisaiRows()

            // クローン情報設定
            this.cloneData = dolly.clone(this.getCloneTargetMethod())
            resolve()
          })
      })
    },
    // viewMixins の validateAll を上書き
    validateAll (refs, prefix) {
      console.log('JuchuEdit', 'validateAll', refs, prefix)
      let result
      const ctrls = Object.keys(refs)
      ctrls.forEach(c => {
        if ((prefix === undefined && !c.includes('-')) || (prefix !== undefined && c.indexOf(prefix) === 0)) {
          console.log('JuchuEdit', 'validateAll', 'forEach', c)
          let targets = []
          if (Array.isArray(refs[c])) {
            targets = targets.concat(refs[c])
          } else {
            targets.push(refs[c])
          }
          targets.forEach(t => {
            if (t === undefined) { return }
            if (t[controls.VALIDATE_METHOD] === undefined) { return }
            if (t[controls.GET_INVALID_METHOD] === undefined) { return }
            t[controls.VALIDATE_METHOD]()
            const res = t[controls.GET_INVALID_METHOD]()
            if (res === undefined) { return }
            result = res
          })
        } else {
          console.log('JuchuEdit', 'validateAll', 'forEach', 'skip', c)
        }
      })
      console.log('JuchuEdit', 'validateAll', result)
      return result === undefined
    },
    onMeisaiEditClosed (e, row) {
      if (!e) { return false }

      // TODO 明細行の更新時
    },
    onHinmokuEditClosed (e, row, isRecalc) {
      const recalc = isRecalc || false
      console.log('JuchuEdit', e, row)
      if (!e) { return false }
      if (recalc) {
        const suryo = row.juchuSuryo || 0
        const tanka = row.tanka || 0
        console.log('JuchuEdit', suryo, tanka)
        if (!window.isFinite(suryo) || !window.isFinite(tanka)) { return }
        row.kingaku = parseInt(suryo, 10) * parseInt(tanka, 10)

        this.$set(row, 'kingaku', row.kingaku)

        console.log('JuchuEdit', row.kingaku, this.rec)
      }

      this.calcMeisaiRows(row.trJuchuMeisaiId)
    },
    calcMeisaiRows (id) {
      // const meisai = this.rec.juchuMeisai.find(m => {
      //   return m.id === id
      // })
      // const amount = meisai.juchuHinmoku.filter(h => {
      //   // 正常に計算された結果のみ抽出
      //   return window.isFinite(h.kingaku)
      // }).map(h => {
      //   // 金額のみの配列に変換
      //   return parseInt(h.kingaku, 10)
      // }).reduce((a, c) => {
      //   // 合計値算出
      //   return a + c
      // })
      // console.log('JuchuEdit', 'calcMeisaiRows', amount)
      // meisai.seikyuKingaku = amount
      this.redrawMeisaiRow(id)
    },
    copyMeisaiRow (row) {
      const appendRow = dolly.clone(row)
      const currentMaxNo = Math.max((this.rec.juchuMeisaiMaxNo ?? 0), Math.max.apply(null, this.rec.juchuMeisai.map(m => m.juchuMeisaiNo)))
      console.log('JuchuEdit', appendRow)
      appendRow.id = 0
      appendRow.juchuMeisaiNo = !window.isFinite(currentMaxNo) ? 1 : currentMaxNo + 1
      appendRow.juchuHinmoku.forEach(h => {
        h.id = 0
        h.trJuchuMeisaiNo = appendRow.juchuMeisaiNo
      })
      this.rec.juchuMeisai.push(appendRow)
    },
    copyHinmokuRow (row, parentRow) {
      console.log('JuchuEdit', 'copyHinmokuRow', row)
      const parent = this.rec.juchuMeisai.find(m => {
        return m.juchuMeisaiNo === row.trJuchuMeisaiNo
      }) || parentRow

      const appendRow = dolly.clone(row)
      const currentMaxNo = Math.max((parent.juchuHinmokuMaxNo ?? 0), Math.max.apply(null, parent.juchuHinmoku.map(m => m.juchuHinmokuNo)))
      console.log('JuchuEdit', appendRow)
      appendRow.id = 0
      appendRow.juchuHinmokuNo = !Number.isNaN(currentMaxNo) ? 1 : currentMaxNo + 1
      parent.juchuHinmoku.push(appendRow)
      this.redrawMeisaiRow(parent.id)
    },
    moveUpMeisaiRow (row) {
      const index = this.rec.juchuMeisai.indexOf(row)
      if (index === 0 || index === -1) { return }
      this.rec.juchuMeisai.splice(
        index - 1,
        2,
        this.rec.juchuMeisai[index],
        this.rec.juchuMeisai[index - 1])
    },
    moveUpHinmokuRow (row, parentRow) {
      console.log('JuchuEdit', 'moveUpHinmokuRow', row)
      const parent = this.rec.juchuMeisai.find(m => {
        return m.juchuMeisaiNo === row.trJuchuMeisaiNo
      }) || parentRow
      const index = parent.juchuHinmoku.indexOf(row)
      console.log('JuchuEdit', 'moveUpHinmokuRow', 'index', index)

      if (index === 0 || index === -1) { return }
      parent.juchuHinmoku.splice(
        index - 1,
        2,
        parent.juchuHinmoku[index],
        parent.juchuHinmoku[index - 1])
    },
    moveDownMeisaiRow (row) {
      const index = this.rec.juchuMeisai.indexOf(row)
      if (index === this.rec.juchuMeisai.length - 1 || index === -1) { return }
      this.rec.juchuMeisai.splice(
        index,
        2,
        this.rec.juchuMeisai[index + 1],
        this.rec.juchuMeisai[index])
    },
    moveDownHinmokuRow (row, parentRow) {
      console.log('JuchuEdit', 'moveDownHinmokuRow', row)
      const parent = this.rec.juchuMeisai.find(m => {
        return m.juchuMeisaiNo === row.trJuchuMeisaiNo
      }) || parentRow
      const index = parent.juchuHinmoku.indexOf(row)
      console.log('JuchuEdit', 'moveDownHinmokuRow', 'index', index)

      if (index === parent.juchuHinmoku.length - 1 || index === -1) { return }
      parent.juchuHinmoku.splice(
        index,
        2,
        parent.juchuHinmoku[index + 1],
        parent.juchuHinmoku[index])
    },
    deleteMeisaiRow (row) {
      const index = this.rec.juchuMeisai.indexOf(row)
      row.delFlg = true
      this.$set(this.rec.juchuMeisai, index, row)
    },
    deleteHinmokuRow (row, parentRow) {
      console.log('JuchuEdit', 'deleteHinmokuRow', row)
      const parent = this.rec.juchuMeisai.find(m => {
        return m.juchuMeisaiNo === row.trJuchuMeisaiNo
      }) || parentRow
      const index = parent.juchuHinmoku.indexOf(row)

      row.delFlg = true
      parent.juchuHinmoku.splice(index, 1, row)
    },
    restoreMeisaiRow (row) {
      const index = this.rec.juchuMeisai.indexOf(row)
      row.delFlg = false
      this.$set(this.rec.juchuMeisai, index, row)
    },
    restoreHinmokuRow (row, parentRow) {
      console.log('JuchuEdit', 'restoreHinmokuRow', row)
      const parent = this.rec.juchuMeisai.find(m => {
        return m.juchuMeisaiNo === row.trJuchuMeisaiNo
      }) || parentRow
      const index = parent.juchuHinmoku.indexOf(row)

      row.delFlg = false
      parent.juchuHinmoku.splice(index, 1, row)
    },
    redrawMeisaiRow (id) {
      if (id === undefined) {
        this.$set(this, 'meisaiDialogTarget', dolly.clone(this.meisaiDialogTarget))
        return
      }
      const row = this.rec.juchuMeisai.find(m => {
        return m.id === id
      })
      const index = this.rec.juchuMeisai.indexOf(row)
      console.log('JuchuEdit', 'redrawMeisaiRow', id, index)
      if (index === this.rec.juchuMeisai.length - 1 || index === -1) { return }
      this.rec.juchuMeisai.splice(
        index,
        1,
        this.rec.juchuMeisai[index])
    },
    onMeisaiDialogOpenClick (row, isCreate) {
      console.log('JuchuEdit', 'onMeisaiDialogOpenClick', row, isCreate)
      const create = isCreate || false
      this.meisaiDialogTarget = create ? {
        sagyoYoteiYmdString: this.baseYmd,
        juchuKingaku1: {},
        juchuHinmoku: [],
        hacchuKihon: {
          hacchuKingaku1: {}
        },
        sagyoMeisai: {},
        sagyoKingaku1: {},
        sagyoHinmoku: [],
        ninushi: { torihikisakiCd: null },
        hatsuchi: { hacchakuchiCd: null },
        oroshisaki: { torihikisakiCd: null },
        chakuchi: { hacchakuchiCd: null }
      } : dolly.clone(row)

      this.isShowMeisaiDialog = true
      this.$nextTick(() => {
        this.clearScrollStatusForDialog()
      })
      console.log('JuchuEdit', 'onMeisaiDialogOpenClick', this.meisaiDialogTarget, this.isShowMeisaiDialog)
    },
    onCloseMeisaiDialogClick (e) {
      this.isShowMeisaiDialog = false
    },
    onMeisaiDialogSave (e) {
      console.log('JuchuEdit', 'onMeisaiDialogSave', this.meisaiDialogTarget)

      const isValid = this.validateAll(this.$refs, 'meisaiDialog')
      console.log('JuchuEdit', 'onMeisaiDialogSave', 'validate', isValid)
      if (!isValid) return

      this.isShowMeisaiDialog = false
      const result = this.meisaiDialogTarget

      if (result !== null) {
        const index = this.rec.juchuMeisai
          .map(m => m.juchuMeisaiNo)
          .indexOf(this.meisaiDialogTarget.juchuMeisaiNo)
        console.log('JuchuEdit', 'onMeisaiDialogSave', 'Index', index)

        // TODO ここで必要な値を設定する
        result.ninushi = result.ninushi || {}
        result.ninushiId = 0
        result.ninushiNm = ''
        if (result.ninushi && result.ninushi.torihikisakiCd !== '') {
          const h = this.torihikisakiList.find(l => {
            return l.torihikisakiCd === result.ninushi.torihikisakiCd
          })
          if (h) {
            result.ninushi = h
            result.ninushiId = h.id
            result.ninushiNm = `${h.torihikisakiCd}:${h.torihikisakiNm}`
          }
        }

        result.hatsuchi = result.hatsuchi || {}
        result.hatsuchiId = 0
        result.hatsuchiNm = ''
        if (result.hatsuchi && result.hatsuchi.hacchakuchiCd !== '') {
          const h = this.hacchakuchiList.find(l => {
            return l.hacchakuchiCd === result.hatsuchi.hacchakuchiCd
          })
          if (h) {
            result.hatsuchi = h
            result.hatsuchiId = h.id
            result.hatsuchiNm = `${h.hacchakuchiCd}:${h.hacchakuchiNm}`
          }
        }

        result.oroshisaki = result.oroshisaki || {}
        result.oroshisakiId = 0
        result.oroshisakiNm = ''
        if (result.oroshisaki && result.oroshisaki.torihikisakiCd !== '') {
          const h = this.torihikisakiList.find(l => {
            return l.torihikisakiCd === result.oroshisaki.torihikisakiCd
          })
          if (h) {
            result.oroshisaki = h
            result.oroshisakiId = h.id
            result.oroshisakiNm = `${h.torihikisakiCd}:${h.torihikisakiNm}`
          }
        }

        result.chakuchi = result.chakuchi || {}
        result.chakuchiId = 0
        result.chakuchiNm = ''
        if (result.chakuchi && result.chakuchi.hacchakuchiCd !== '') {
          const h = this.hacchakuchiList.find(l => {
            return l.hacchakuchiCd === result.chakuchi.hacchakuchiCd
          })
          if (h) {
            result.chakuchi = h
            result.chakuchiId = h.id
            result.chakuchiNm = `${h.hacchakuchiCd}:${h.hacchakuchiNm}`
          }
        }

        if (index === -1) {
          // TODO ここで必要な初期値を設定する
          const currentMaxNo = Math.max((this.rec.juchuMeisaiMaxNo ?? 0), Math.max.apply(null, this.rec.juchuMeisai.map(m => m.juchuMeisaiNo)))
          result.juchuMeisaiNo = !window.isFinite(currentMaxNo) ? 1 : currentMaxNo + 1
          result.delFlg = false

          result.juchuHinmoku.forEach(h => {
            h.trJuchuMeisaiNo = result.juchuMeisaiNo
          })

          console.log('JuchuEdit', 'onMeisaiDialogSave', 'push', result)
          this.rec.juchuMeisai.push(result)
        } else {
          console.log('JuchuEdit', 'onMeisaiDialogSave', 'splice', result)
          this.rec.juchuMeisai.splice(index, 1, result)
        }
      }

      this.isShowMeisaiDialog = false
      this.meisaiDialogTarget = {
        juchuKingaku1: {},
        juchuHinmoku: [],
        hacchuKihon: {
          hacchuKingaku1: {}
        },
        sagyoMeisai: {},
        sagyoKingaku1: {},
        sagyoHinmoku: [],
        ninushi: { torihikisakiCd: null },
        hatsuchi: { hacchakuchiCd: null },
        oroshisaki: { torihikisakiCd: null },
        chakuchi: { hacchakuchiCd: null }
      }
      this.calculateMeisaiRows()
      this.calcMeisaiRows(result.trJuchuMeisaiId)
    },
    onHinmokuDialogOpenClick (row, isCreate) {
      console.log('JuchuEdit', 'onHinmokuDialogOpenClick', row, isCreate)
      const create = isCreate || false
      this.hinmokuDialogTarget = create ? {
        juchuKingaku1: {},
        hinmei: { hinmeiCd: null },
        hinmokuSbtMst: {},
        unitKbnMst: {}
      // } : dolly.clone(row)
      } : row
      this.isShowHinmokuDialog = true
      console.log('JuchuEdit', 'onHinmokuDialogOpenClick', this.hinmokuDialogTarget, this.isShowHinmokuDialog)
    },
    onCloseHinmokuDialogClick (e) {
      this.isShowHinmokuDialog = false
    },
    onHinmokuDialogSave (parentRow) {
      console.log('JuchuEdit', 'onHinmokuDialogSave', this.hinmokuDialogTarget, parentRow)

      const isValid = this.validateAll(this.$refs, 'hinmokuDialog')
      console.log('JuchuEdit', 'onHinmokuDialogSave', 'validate', isValid)
      if (!isValid) return

      this.isShowHinmokuDialog = false
      const result = this.hinmokuDialogTarget

      if (result !== null) {
        const parent = this.rec.juchuMeisai.find(m => {
          return m.juchuMeisaiNo === result.trJuchuMeisaiNo
        }) || parentRow
        const row = parent.juchuHinmoku.find(h => {
          return h.juchuHinmokuNo === result.juchuHinmokuNo
        })
        const index = parent.juchuHinmoku.indexOf(row)
        console.log('JuchuEdit', 'onHinmokuDialogSave', 'Index', index)

        // TODO ここで必要な値を設定する
        result.trJuchuMeisaiNo = parent.juchuMeisaiNo

        result.hinmei = result.hinmei || {}
        result.mstHinmeiId = 0
        result.hinmeiNm = ''
        if (result.hinmei && result.hinmei.hinmeiCd !== '') {
          if (this.rec.torihikisakiId !== '') {
            const a = this.torihikisakiList.find(l => {
              return l.id === this.rec.torihikisakiId
            })
            if (a) {
              const h = this.hinmeiList.find(l => {
                return l.torihikisakiCd === a.torihikisakiCd && l.hinmeiCd === result.hinmei.hinmeiCd
              })
              if (h) {
                result.hinmei = h
                result.mstHinmeiId = h.id
                result.hinmeiNm = `${h.hinmeiCd}:${h.hinmeiNm}`
              }
            }
          }
        }

        result.hinmokuSbtMst = result.hinmokuSbtMst || {}
        result.hinmokuSbtNm = ''
        if (result.hinmokuSbt !== '') {
          const h = this.shubetsuList.find(l => {
            return l.sbtShuruiCd === 'GVIJ02' && l.sbtCd === result.hinmokuSbt
          })
          if (h) {
            result.hinmokuSbtMst = h
            result.hinmokuSbtNm = `${h.sbtCd}:${h.sbtNm}`
          }
        }

        result.unitKbnMst = result.unitKbnMst || {}
        result.unitKbnNm = ''
        if (result.unitKbn !== '') {
          const h = this.shubetsuList.find(l => {
            return l.sbtShuruiCd === 'SVI001' && l.sbtCd === result.unitKbn
          })
          if (h) {
            result.unitKbnMst = h
            result.unitKbnNm = `${h.sbtCd}:${h.sbtNm}`
          }
        }

        result.juchuKingaku1.kihonUnchin = result.kingaku

        if (index === this.rec.juchuMeisai.length - 1 || index === -1) {
          // TODO ここで必要な初期値を設定する
          const currentMaxNo = Math.max((parent.juchuHinmokuMaxNo ?? 0), Math.max.apply(null, parent.juchuHinmoku.map(m => m.juchuHinmokuNo)))
          result.juchuHinmokuNo = !window.isFinite(currentMaxNo) ? 1 : currentMaxNo + 1
          result.delFlg = false

          console.log('JuchuEdit', 'onHinmokuDialogSave', 'push', result)
          parent.juchuHinmoku.push(result)
        } else {
          console.log('JuchuEdit', 'onHinmokuDialogSave', 'splice', result)
          parent.juchuHinmoku.splice(index, 1, result)
        }
      }

      this.isShowHinmokuDialog = false
      this.hinmokuDialogTarget = {
        juchuKingaku1: {},
        hinmei: { hinmeiCd: null },
        hinmokuSbtMst: {},
        unitKbnMst: {}
      }
      this.calcMeisaiRows(result.trJuchuMeisaiId)
    },
    onDialogKingakuBlur (refObj) {
      this.$set(this.meisaiDialogTarget, 'juchuKingaku1', refObj)
    },
    calculateMeisaiRows () {
      console.log('JuchuEdit', 'calculateMeisaiRows', this.rec.juchuMeisai)
      this.rec.juchuMeisai.forEach(m => {
        const l = this.convertKingakuItemsToArray(m.juchuKingaku1)
        if (l.length === 0) { return 0 }
        const amount = l.reduce((a, c) => a + c)

        const index = this.rec.juchuMeisai.indexOf(m)
        m.seikyuKingaku = filter.numericFormatter(amount)
        this.rec.juchuMeisai.splice(index, 1, m)
      })
      console.log('JuchuEdit', 'calculateMeisaiRows', this.rec.juchuMeisai)
    },
    convertKingakuItemsToArray: function (target) {
      const props = [
        'kihonUnchin',
        'jikanWarimashiKingaku',
        'kyoriWarimashiKingaku',
        'keisuWarimashiKingaku',
        'nenryoWarimashiKingaku',
        'hiwayPrice',
        'userKingakuKazei1',
        'userKingakuKazei2',
        'userKingakuKazei3',
        'userKingakuKazei4',
        'userKingakuKazei5',
        'userKingakuKazei6',
        'userKingakuKazei7',
        'userKingakuKazei8',
        'userKingakuKazei9',
        'userKingakuKazei10',
        'userKingakuHikazei1',
        'userKingakuHikazei2',
        'userKingakuHikazei3',
        'userKingakuHikazei4',
        'userKingakuHikazei5',
        'userKingakuHikazei6',
        'userKingakuHikazei7',
        'userKingakuHikazei8',
        'userKingakuHikazei9',
        'userKingakuHikazei10',
        'userKingakuUchizei1',
        'userKingakuUchizei2',
        'userKingakuUchizei3',
        'userKingakuUchizei4',
        'userKingakuUchizei5',
        'userKingakuUchizei6',
        'userKingakuUchizei7',
        'userKingakuUchizei8',
        'userKingakuUchizei9',
        'userKingakuUchizei10'
      ]

      const l = props.filter(p => {
        return window.isFinite(target[p])
      }).map(p => {
        return Number.parseFloat(target[p])
      }).map(p => {
        return Number.isNaN(p) ? 0 : p
      })
      return l
    },
    /**
     * 戻るボタンクリック
     */
    onReturnClick () {
      console.log('JuchuEdit', 'onReturnClick')
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.transitionBack(opt)
    },
    /**
     * キャンセルボタンクリック
     */
    onCancelClick () {
      console.log('JuchuEdit', 'onCancelClick')
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    /**
     * 削除ボタンクリック
     */
    onDeleteClick () {
      console.log('JuchuEdit', 'onDeleteClick')
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/TrJuchuKihon/DeleteWithChildren?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.delete(opt)
    },
    /**
     * 新規ボタンクリック
     */
    onCreateClick () {
      console.log('JuchuEdit', 'onCreateClick')
      this.id = 0
      this.transition(0, { id: 0 }, this.initialize)
    },
    /**
     * 複写ボタンクリック
     */
    onCopyClick () {
      console.log('JuchuEdit', 'onCopyClick')
      const self = this
      const opt = {
        setIdMethod: () => {
          // /* eslint no-debugger: "warn" */
          // debugger

          self.id = 0
          // 受注基本
          self.rec.id = 0
          self.rec.juchuNo = ''
          self.rec.juchuKingaku1.id = 0
          // 受注明細
          self.rec.juchuMeisai.forEach(function (jm) {
            jm.id = 0
            jm.juchuKingaku1.id = 0
            // 受注品目
            jm.juchuHinmoku.forEach(function (jh) {
              jh.id = 0
              jh.juchuKingaku1.id = 0
            })
            // 作業明細
            jm.sagyoMeisai.id = 0
            jm.sagyoKingaku1.id = 0
            // 作業品目
            jm.sagyoHinmoku.forEach(function (sh) {
              sh.id = 0
              sh.sagyoKingaku1.id = 0
            })
          })
        }
      }
      this.copyInputs(opt)
    },
    /**
     * 注文受書出力ボタンクリック
     */
    onOrderReportClick () {
      console.log('JuchuEdit', 'onOrderReportClick')
    },
    /**
     * 保存ボタンクリック
     */
    onSaveClick () {
      console.log('JuchuEdit', 'onSaveClick')
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.rec.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.transition(1, { id: id }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        judgeKeyChangedMethod: function (data) {
          // return data.hacchakuchiCd !== this.rec.hacchakuchiCd
          // TODO: ユニークキーの変更判定
          return false
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.rec.id === undefined || this.rec.id === 0) {
        console.log('JuchuEdit', 'onSaveClick', 'UpdateWithChildren', this.rec.id)
        f = this.HttpClient.put(`/api/v1/TrJuchuKihon/UpdateWithChildren?id=${0}`, this.rec)
      } else {
        console.log('JuchuEdit', 'onSaveClick', 'UpdateWithChildren', this.rec.id)
        f = this.HttpClient.put(`/api/v1/TrJuchuKihon/UpdateWithChildren?id=${this.rec.id}`, this.rec)
      }
      return f
    },
    registerValidate () {
      // TODO 登録・更新時クライアント側Validate
      return true
    },
    deleteValidate: function () {
      // TODO 削除時クライアント側Validate
      return true
    },
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      const self = this
      this.rec.juchuMeisai.forEach(function (item) {
        // 発地設定
        if ((item.hatsuchiId) && item.hatsuchiId !== '' && item.hatsuchiId !== null) {
          const hatsuchi = {
            id: item.hatsuchiId,
            ymdhms: (item.hatsuchiYmd !== undefined && item.hatsuchiYmd !== null && item.hatsuchiYmd !== '' ? item.hatsuchiYmd : '2999/12/31') + (item.hatsuchiHms !== undefined && item.hatsuchiHms !== null && item.hatsuchiHms !== '' ? item.hatsuchiHms : '00:00')
          }

          if (self.mapData.length > 0) {
            self.mapData.push(hatsuchi)
          } else {
            self.mapData = [hatsuchi]
          }
        }
        // 着地設定
        if ((item.chakuchiId) && item.chakuchiId !== '' && item.chakuchiId !== null) {
          const chakuchi = {
            id: item.chakuchiId,
            ymdhms: (item.chakuchiYmd !== undefined && item.chakuchiYmd !== null && item.chakuchiYmd !== '' ? item.chakuchiYmd : '2999/12/31') + (item.chakuchiHms !== undefined && item.chakuchiHms !== null && item.chakuchiHms !== '' ? item.chakuchiHms : '00:00')
          }

          if (self.mapData.length > 0) {
            self.mapData.push(chakuchi)
          } else {
            self.mapData = [chakuchi]
          }
        }
      })

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },
    changeTokuisakiInfo: function () {
      if (this.rec.torihikisakiId === 0) {
        this.currentMstKingaku = {}
      } else {
        this.HttpClient
          .get(`/api/v1/MstKingaku/FindByType?id=${this.rec.torihikisakiId}&kinKbn=${1}`)
          .then((data) => {
            this.currentMstKingaku = data.payload
          })
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      // 基準日初期値設定
      this.baseYmd = date.getCurrentDate()
      const x = {
        juchuEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id : null,
        juchuYmdString: this.baseYmd,
        ikkatsuSeikyuFlg: true,
        juchuMeisai: [],
        juchuKingaku1: {},
        hacchuKihon: {
          hacchuKingaku1: {}
        }
      }
      this.rec = x
    }
  }
}
